import { API } from 'aws-amplify';
import { UserProfile } from '../models/UserProfile';

export class UserProfileStore {

  loadCurrentUserProfile = async (): Promise<UserProfile> => {
    console.log('*************** loading current user profile ************************');
    const currentUserProfile = await API.get('restAPI', '/userProfile/practitioner', {});
    if (currentUserProfile) {
      return new UserProfile(currentUserProfile);
    } 
    return undefined;
  }

  updateUserProfile = async (userProfile: UserProfile): Promise<UserProfile> => {
    let requestParams = {
      body : userProfile
    };
    const updatedUserProfile = await API.put('restAPI', '/userProfile/practitioner', requestParams);

    return new UserProfile(updatedUserProfile);
  }
}